export class OkrModel {
    constructor(okr) {
        this.id = okr.id;
        this.name = okr.name ?? '';
        this.department = okr.department?.name ?? '';
        this.fiscalQuarter = this.getQuarterOkr(okr.quarter, okr.year);
        this.type = this.getType(okr.type);
        this.colorType = this.getColorType(okr.type)
        this.humans = okr.okr_users ?? []
        this.human = this.getHuman(okr.okr_users);
        this.exp = this.getExp(okr.completion_rate, okr.exp_target);
        this.totalExp = this.getTotalExp(okr.completion_rate, okr.exp_target)
        this.leader = okr.leader?.name ?? '';
        this.status = okr.status;
        this.deadline = okr.completion_rate;
    }

    getQuarterOkr(value, year) {
        if (!value || !year) return ''
        return `${quarterOptions[value-1].label}/${year}`
    }

    getType(value) {
        switch (value) {
            case 1:
                return 'Cấp phòng ban'
            case 2:
                return 'Cấp công ty'
            default:
                return ''
        }
    }

    getTotalExp(kpi, target) {
        return (kpi * target) / 100
    }

    getExp(kpi, target) {
        const actual = (kpi * target) / 100
        if (!target) return ''
        return `${actual}/${target}`
    }

    getHuman(value) {
        if (value.length > 1) {
            return `${value[0].name} và ${value.length - 1} người khác`
        }
        if (value.length > 0) {
            return `${value[0].name}`
        }
    }
    getColorType(value) {
        switch (value) {
            case 1:
                return 'color-green'
            case 2:
                return 'color-violet'
            default:
                return ''
        }
    }
}

export class ResultOkrModel {
    constructor(okr) {
        this.id = okr.id;
        this.name = okr.okr?.name ?? '';
        this.department = okr.okr?.department?.name ?? '';
        this.fiscalQuarter = this.getQuarterOkr(okr.okr?.quarter, okr.okr?.year);
        this.typeString = this.getType(okr.okr?.type);
        this.bgType = this.getColorType(okr.okr?.type)
        this.exp = okr?.exp ?? 0
        this.leader = okr.okr?.leader?.name ?? '';
        this.status = this.getLabelStatus(okr.okr?.status);
        this.bgStatus = this.getBgStatus(okr.okr?.status)
        this.deadline = this.getLabelDeadline(okr.okr?.completion_rate);
        this.comment = okr?.feedback ?? '';
    }
    getLabelDeadline(value) {
        if (!value && value !== 0) return ''
        return `${value}%`
    }
    getType(value) {
        switch (value) {
            case 1:
                return 'Cấp phòng ban'
            case 2:
                return 'Cấp công ty'
            default:
                return ''
        }
    }
    getColorType(value) {
        switch (value) {
            case 1:
                return 'color-green'
            case 2:
                return 'color-violet'
            default:
                return ''
        }
    }
    getQuarterOkr(value, year) {
        if (!value || !year) return ''
        return `${quarterOptions[value-1].label}/${year}`
    }
    getLabelStatus(value) {
        switch (value) {
            case 6:
                return 'Hoàn thành (Đạt KPIs mục tiêu)'
            case 4:
                return 'Đạt KPI cam kết - 80% EXP'
            case 1:
                return 'Không đạt'
            default:
                return 'Chưa đánh giá'
        }
    }
    getBgStatus(value) {
        switch (value) {
            case 6:
                return 'color-green'
            case 4:
                return 'color-warning'
            case 1:
                return 'color-red'
            default:
                return ''
        }
    }
}

export const quarterOptions = [
    {
        label: 'Quý I',
        value: 1,
    },
    {
        label: 'Quý II',
        value: 2,
    },
    {
        label: 'Quý III',
        value: 3,
    },
    {
        label: 'Quý IV',
        value: 4,
    }
]

export const statusOkrOption = [
    {
        label: 'Chưa đánh giá',
        value: 0,
    },
    {
        label: 'Không đạt',
        value: 1,
    },
    {
        label: 'Đạt KPI cam kết - 80% EXP',
        value: 4,
    },
    {
        label: 'Hoàn thành (Đạt KPIs mục tiêu)',
        value: 6,
    }
]

export const typeOkrOption = [
    {
        label: 'OKR cấp phòng ban',
        value: 1,
    },
    {
        label: 'OKR cấp công ty',
        value: 2,
    }
]
